import { atom } from 'recoil';
import { UserProfile } from '@/common/types';

export const UserProfileState = atom<UserProfile>({
    key: 'UserProfileState',
    default: undefined,
});
